import Policy from "../components/Policy";

const sections = [
  { h: "Student cancellations", p: "You can cancel a confirmed booking from your dashboard before move-in. Refunds follow our Refund Policy." },
  { h: "Owner cancellations", p: "If an owner cancels a confirmed booking, Hostro guarantees a full refund to the student within 3 business days, and the owner's account is flagged for review." },
  { h: "No-show", p: "If a student doesn't show up by the move-in date and doesn't notify, the booking auto-cancels after 48 hours. Deposit refund is at the owner's discretion." },
  { h: "Force majeure", p: "Cancellations due to natural disasters, government orders, or force majeure are fully refundable." },
  { h: "Contact", p: "support@hostro.in" },
];
export default function Cancellation() {
  return <Policy title="Cancellation Policy" eyebrow="Legal" sections={sections} lastUpdated="December 2025"/>;
}
